import { LinearProgress } from '@mui/material';
import { useMemo } from 'react';
import { useAppTheme } from '../../logic/useAppTheme';


export function LoadingScreen() {
  const theme = useAppTheme() 
  const barColor = useMemo(() => {
    const primary = (theme.palette.primary?.main || '').toString().toLowerCase();
    // MUI v5 default primary.main is #1976d2; show neutral gray until branding overrides it
    const isDefaultBlue = primary === '#1976d2';
    return isDefaultBlue ? '#9e9e9e' : theme.palette.primary.main;
  }, [theme.palette.primary?.main]);
  return (
    <LinearProgress
      color="inherit"
      sx={{
        width: '100%',
        // Use neutral gray until branding is applied; then switch to theme primary
        '& .MuiLinearProgress-bar': {
          backgroundColor: barColor,
        },
      }}
    />
  );
}
